import Parser from "@helpers/parser";
import { IconFilterOff } from "@tabler/icons-react";

import { Button, ChipPicker, Text } from "@fragments";

import { MEMBER_ROLES, SUBSCRIPTION_STATUSES } from "../../../enums";

import "./styles.scss";

export default function FiltersBar({ filters, plans, plansLoading, onToggle, onClear }) {
  const hasFilters =
    filters.roles.length > 0 ||
    filters.plan_ids.length > 0 ||
    filters.subscription_statuses.length > 0;

  const planOptions = plansLoading
    ? []
    : plans.map((plan) => ({
        id: plan.id,
        label: plan.price
          ? `${plan.label} — R$ ${Parser.price.brl(plan.price)}`
          : plan.label,
      }));

  function handleToggle(filterKey) {
    return (_, option) => onToggle(filterKey, option.id);
  }

  return (
    <div className="members-list-filters">
      <Text.span contrast={5}>Filtrar por</Text.span>

      <ChipPicker
        title="Permissão"
        multiple
        value={filters.roles}
        options={MEMBER_ROLES}
        onChange={handleToggle("roles")}
      />
      <ChipPicker
        title="Plano"
        multiple
        searchable
        value={filters.plan_ids}
        options={planOptions}
        onChange={handleToggle("plan_ids")}
      />
      <ChipPicker
        title="Status da assinatura"
        multiple
        value={filters.subscription_statuses}
        options={SUBSCRIPTION_STATUSES}
        onChange={handleToggle("subscription_statuses")}
      />

      {hasFilters && (
        <Button
          color="overlay"
          size="small"
          startIcon={<IconFilterOff size={16} stroke={2} />}
          text="Limpar filtros"
          onClick={onClear}
          preventLoading
        />
      )}
    </div>
  );
}
